export default "/images/vendor/flag-icon-css/flags/1x1/cu.svg?1452c504ef675071dcdf6ef2a44e55df";